import script from "./SolutionDetail.vue?vue&type=script&setup=true&name=SolutionDetail&lang=js"
export * from "./SolutionDetail.vue?vue&type=script&setup=true&name=SolutionDetail&lang=js"

import "./SolutionDetail.vue?vue&type=style&index=0&id=290fa622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-290fa622"]])

export default __exports__